/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { FC, useCallback, useEffect, useState } from "react";
import _ from "lodash";
// import { v4 as uuidv4 } from "uuid";
import Button from "../Button/Button";

type ID = number | string;
type Orientation = "horizontal" | "vertical";

interface SelectorGroupOption {
	id: ID;
	text: string;
	icon?: React.ReactElement;
}

interface Props {
	options: SelectorGroupOption[];
	onChange: (selected: ID[]) => void;
	value?: ID[];
	orientation?: Orientation;
	className?: string;
	buttonClassName?: string;
	multiple?: boolean;
}

const SelectorGroup: FC<Props> = ({
	value,
	options,
	onChange,
	orientation = "vertical",
	className = "",
	buttonClassName = "",
	multiple = true,
}) => {
	const [selections, setSelections] = useState<ID[]>(value || []);

	useEffect(() => {
		setSelections(value || []);
	}, [value]);

	const toggleSelected = useCallback(
		(option: SelectorGroupOption) => {
			let _selections;
			if (multiple) {
				const id = _.find(selections, (selection) => selection === option.id);

				_selections = id
					? selections.filter((selection) => selection !== option.id)
					: [...selections, option.id];
				setSelections(_selections);
			} else {
				_selections = [option.id];
				setSelections(_selections);
			}

			if (onChange) {
				onChange(_selections);
			}
		},
		[onChange, selections],
	);

	return (
		<div
			className={`${
				orientation === "vertical"
					? "display_flex flex_col"
					: "display_flex flex_row"
			} ${className}`}
		>
			{options.map((option) => (
				<Button
					key={option.id}
					onClick={() => toggleSelected(option)}
					icon={option.icon}
					className={`${
						selections.includes(option.id) ? "active" : ""
					} ${buttonClassName}`}
					variant="outline"
					extend
					orientation="right"
					scale="small"
				>
					{option.text}
				</Button>
			))}
		</div>
	);
};

export default SelectorGroup;
